import { render, staticRenderFns } from "./Wp_mt_my_child_num_income.vue?vue&type=template&id=278c7044&scoped=true&"
import script from "./Wp_mt_my_child_num_income.vue?vue&type=script&lang=js&"
export * from "./Wp_mt_my_child_num_income.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278c7044",
  null
  
)

export default component.exports